import Vue from 'vue'
import Router from 'vue-router'
import AddressSearch from './views/AddressSearch.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'search',
      component: AddressSearch,
    }, {
      path: '/worklist',
      component: () => import('./views/AddressSearch.vue')  // default route
    }, {
      path: '/other-lists',
      component: () => import('./views/CancelledAddresses.vue')
    }, {
      path: '/planner/worklist',
      component: () => import('./views/planner/WorklistPlanner.vue')
    }, {
      path: '/planner/list/:assignmentIds',
      component: () => import('./views/planner/WorklistPlannerAddresses')
    }, {
      path: '/planner/planning',
      component: () => import('./views/planner/Planning.vue')
    }, {
      path: '/planner/resources',
      component: () => import('./views/planner/ResourcePlanning.vue')
    }, {
      path: '/mechanic/worklist',
      component: () => import('./views/WorklistMechanic.vue')
    },
    {
      path: '/address',
      name: 'address',
      component: () => import('./views/Address.vue')
    },
    {
      path: '/address/planner',
      name: 'planner survey',
      component: () => import('./views/Planner.vue')
    },
    {
      path: '/admin/address',
      name: 'addressAdmin',
      component: () => import('./views/Address.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: '/admin/upload',
      name: 'admin-upload',
      component: () => import('./views/admin/Upload.vue')
    },
    {
      path: '/admin/nestor',
      name: 'nestor-download',
      component: () => import('./views/admin/NestorDownload.vue')
    },
    {
      path: '/admin/assignments',
      name: 'admin-assignments',
      component: () => import('./views/admin/Assignments.vue')
    },
    {
      path: '/admin/assignment',
      name: 'admin-assignment',
      component: () => import('./views/admin/Assignment.vue')
    },
    {
      path: '/admin/clients',
      name: 'admin-clients',
      component: () => import('./views/admin/ClientManager.vue')
    },
    {
      path: '/admin/download',
      component: () => import('./views/admin/Download.vue')
    },
    {
      path: '/admin/statistics',
      name: 'admin-statistics',
      component: () => import('./views/admin/Statistics.vue')
    },
    {
      path: '/admin/configuration',
      name: 'admin-configuration',
      component: () => import('./views/admin/Configuration.vue')
    },
    {
      path: '/admin/to-be-processed',
      name: 'admin-2-be-processed',
      component: () => import('./views/admin/UnfinishedAddresses.vue')
    },
    {
      path: "/questions",
      props: true,
      component: () => import('./components/question/QuestionController.vue')
    },
    {
      path: '*',
      component: () => import('./views/AddressSearch.vue')
    }
  ]
})